import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "./Fdes.scss";
import FdesInformations from "../containers/FdesInformations";
import FdesFormGroup from "./../containers/FdesFormGroup";
import SyntheticResult from "../containers/SyntheticResult";
import ModuleResult from "../containers/ModuleResult";
import Switch from "react-switch";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Loader from "../../../common/components/Loader";
import {
  AFFICHAGERSLT,
  CREATEPDF,
  DOWNLOADXLS,
  DOWNLOADXMLCONFIG,
  DOWNLOADXMLINIES,
  ETAPESRS,
  GRAPHERESULTATS,
  INDICATEURM,
  INDICATEURRS,
  NOMCALCUL,
  NOMPROJET,
  RESULTATSPARETAPES,
  TABLEAUDETAIL,
} from "../constants/metadata";
import EDECLogo from "../../../icons/Pictogramme_EDEC_vert.svg";
import { useParams } from "react-router-dom";
import CustomTooltip from "../../../common/components/CustomTooltip";
import { toast } from "react-toastify";
import { getFdesCalculatorApi } from "../utils/calculus";

const Fdes = ({
  user,
  familyProduct,
  loadFdesParameters,
  isEdited,
  saveFdesForm,
  saveFdesRealTimeForm,
  isSaved,
  loadReference,
  saveFdesResult,
  resultFormIsLoading,
  resultFormIsSaved,
  generateReports,
  readOnly,
  updateCalcul,
  cleanNameForm,
  isGeneratingReports,
  calculIsLoading,
  formIsLoading,
  onUpgradeCalcul,
  getFdesMetadata,
  metadata,
  calcul,
  getCalcul,
  clearCalcul,
  sendXmlToEDEC,
  settings,
  reports,
  isSimulationMode,
  removeReports,
  filesCreatedAfterSave,
  isGenerateButtonDisabled,
  isFormUpdated,
  localEDECIntegration,
  fdesParameters,
}) => {
  const params = useParams();
  const [isAuto, setIsAuto] = useState("Y");
  const [showModal, setShowModal] = useState(false);
  const [createPdf, setCreatePdf] = useState({});
  const [downloadXmlConfig, setDownloadXmlConfig] = useState({});
  const [downloadXmlInies, setDownloadXmlInies] = useState({});
  const [downloadXLS, setDownloadXLS] = useState({});
  const [excludedCouples, setExcludedCouples] = useState([]);
  const isEditMode = !!params.calculId;
  const activeFdes =
    calcul && calcul.model && calcul.model._id
      ? calcul.model
      : familyProduct?.currentFdes;
  const activeFdesId = activeFdes?._id;
  const calculatorApi = getFdesCalculatorApi(activeFdes);
  const isGoogleCalculus = calculatorApi === "google";
  const isApsiviCalculus = calculatorApi === "apsivi";

  const isNotLastModel =
    calcul &&
    calcul.model &&
    calcul.lastModel &&
    calcul.lastModel._id !== calcul.model._id;

  useEffect(() => {
    clearCalcul();
    if (params.calculId) {
      getCalcul(params.calculId);
    }
    //eslint-disable-next-line
  }, [params.calculId, getCalcul, clearCalcul]);

  const fetchParameters = () => {
    if (!activeFdesId) {
      return;
    }

    if (isEditMode && !calcul?._id) {
      return;
    }

    loadFdesParameters(
      activeFdesId,
      calculatorApi,
      isEditMode ? calcul : undefined,
      isEditMode,
    );
  };

  const fetchReference = () => {
    if (familyProduct && familyProduct.currentFdes) {
      loadReference(familyProduct.currentFdes.standard);
    }
  };

  const fetchMetadata = () => {
    if (!activeFdesId) {
      return;
    }

    if (isEditMode && !calcul?._id) {
      return;
    }

    getFdesMetadata(activeFdesId);
  };

  useEffect(
    () => {
      fetchParameters();
      fetchReference();
    }, //eslint-disable-next-line
    [
      activeFdesId,
      calculatorApi,
      isEditMode,
      familyProduct.currentFdes?._id,
      loadFdesParameters,
      loadReference,
      calcul._id,
    ],
  );

  useEffect(() => {
    return () => {
      if (cleanNameForm) cleanNameForm();
    };
  }, [cleanNameForm]);

  useEffect(() => {
    const isAutoSaved = localStorage.getItem("isAuto");
    if (isAutoSaved) {
      setIsAuto(isAutoSaved);
    }
  }, [setIsAuto]);

  useEffect(() => {
    if (calculatorApi) {
      setIsAuto("N");
    }
  }, [calculatorApi, setIsAuto]);

  useEffect(() => {
    if (isNotLastModel) {
      setShowModal(true);
    }
  }, [calcul, isNotLastModel]);

  useEffect(() => {
    fetchMetadata();
    //eslint-disable-next-line
  }, [activeFdesId, isEditMode, calcul._id, getFdesMetadata]);

  useEffect(() => {
    if (!Array.isArray(metadata)) {
      setCreatePdf({});
      setDownloadXmlConfig({});
      setDownloadXmlInies({});
      setDownloadXLS({});
      return;
    }

    setCreatePdf(metadata.find((e) => e.paramId === CREATEPDF) || {});
    setDownloadXmlConfig(
      metadata.find((e) => e.paramId === DOWNLOADXMLCONFIG) || {},
    );
    setDownloadXmlInies(
      metadata.find((e) => e.paramId === DOWNLOADXMLINIES) || {},
    );
    setDownloadXLS(metadata.find((e) => e.paramId === DOWNLOADXLS) || {});
  }, [metadata]);

  useEffect(() => {
    if (settings?.excludedResultValues?.length > 0) {
      const result = settings.excludedResultValues.map((couple) => {
        return { indicator: couple.split("_")[0], step: couple.split("_")[1] };
      });
      setExcludedCouples(result);
    } else setExcludedCouples([]);
  }, [settings]);

  useEffect(() => {
    if (
      (reports?.pdf || reports?.xml) &&
      isEdited &&
      isSimulationMode &&
      removeReports
    ) {
      removeReports();
    }
  }, [resultFormIsSaved]); //eslint-disable-line

  function handleChangeIsAuto() {
    localStorage.setItem("isAuto", isAuto === "Y" ? "N" : "Y");
    isAuto === "N" && handleSaveFdes();
    setIsAuto(isAuto === "Y" ? "N" : "Y");
  }

  function downloadLink(link) {
    window.open(link);
  }

  function handleClickIcon(type) {
    if (reports?.[type] && isGenerateButtonDisabled) {
      if (!filesCreatedAfterSave()) return;
      downloadLink(reports[type]);
    } else if (!!calcul._id && resultFormIsSaved) {
      if (isGenerateButtonDisabled) return;
      generateReports(
        {
          xml: displayDownloadXmlConfig(),
          xmlInies: displayDownloadXmlInies(),
          xls: displayDownloadXLS(),
        },
        calcul._id,
      );
    }
  }

  function handleUpgradeCalcul() {
    if (calcul && calcul._id) {
      onUpgradeCalcul(calcul._id);
      // handleSaveFdes();
    }
    setShowModal(false);
  }

  const handleGenerateClick = () => {
    if (isNotLastModel) {
      toast.error(
        "Impossible de générer les fichiers car le modèle utilisé pour ce calcul n'est plus à jour.",
      );
    } else {
      generateReports(
        {
          xml: displayDownloadXmlConfig(),
          xmlInies: displayDownloadXmlInies(),
          xls: displayDownloadXLS(),
        },
        calcul._id,
      );
    }
  };

  function findMetadata(paramId) {
    if (!Array.isArray(metadata)) {
      return [];
    }

    return metadata.filter((data) => paramId.includes(data.paramId));
  }

  function displayDownloadXmlConfig() {
    if (downloadXmlConfig) return downloadXmlConfig.visible;
    else return true;
  }

  function displayDownloadXmlInies() {
    if (downloadXmlInies) return downloadXmlInies.visible;
    else return false;
  }

  function displayDownloadXLS() {
    if (downloadXLS) return downloadXLS.visible;
    else return false;
  }

  function isSaveButtonDisabled() {
    const baseCondition =
      isAuto === "N"
        ? isEdited
          ? resultFormIsSaved
          : true
        : resultFormIsSaved;
    return (
      (!isSimulationMode && readOnly) || resultFormIsLoading || baseCondition
    );
  }

  function handleSaveResult() {
    if (isSaveButtonDisabled()) {
      return;
    }

    if (calcul && calcul._id) {
      updateCalcul(calcul._id);
      return;
    }

    saveFdesResult();
  }

  function getDownloadFileContent(type) {
    if (isGenerateButtonDisabled && isSaveButtonDisabled()) {
      if (type === "xls" && reports?.xls) return "Excel";
      if (type === "inies" && reports?.inies) return "XML INIES";
      if (type === "pdf" && reports?.pdf) return "PDF";
      if (type === "xml" && reports?.xml) return "XML RE2020";
    }
    if (!isGenerateButtonDisabled && isSaveButtonDisabled()) {
      return createPdf?.name || "Générer les exports";
    }
    return "";
  }

  function handleSaveFdes() {
    if (calculatorApi) {
      saveFdesRealTimeForm(calculatorApi, activeFdesId);
    } else {
      saveFdesForm(activeFdesId);
    }
  }

  const resultsAreStale = isAuto === "N" && isFormUpdated;

  return (
    <div
      className={`row fdes p-0 ${calculIsLoading || formIsLoading ? "loading" : ""
        }`}
    >
      <Loader
        isActive={calculIsLoading || formIsLoading}
        text={"Votre calcul est en cours de chargement"}
      />
      {calcul && calcul.lastModel && calcul.productFamily && (
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Body>
            {calcul && calcul.isCompatible === true
              ? `Ce calcul a été créé avec une version précédente du configurateur de la famille de produits “${calcul.productFamily?.name}”. Par chance cette version précédente et la nouvelle version sont compatibles entre elles ! Ainsi vous pouvez 1/ maintenir ce calcul dans sa version originale, ce qui vous permettra uniquement de visualiser ses résultats, 2/ convertir ce calcul selon la nouvelle version, ce qui vous permettra de l'éditer totalement.`
              : `Ce calcul a été créé avec une version précédente du configurateur de la famille de produits "${calcul.productFamily?.name}". Malheureusement cette version précédente et la nouvelle version sont incompatibles entre elles. Ainsi vous ne pouvez plus éditer ce calcul et vous ne pouvez plus générer de FDES, mais seulement visualiser vos paramètres de calcul et les résultats associés.`}
          </Modal.Body>
          <Modal.Footer>
            {calcul && calcul.isCompatible === true ? (
              <>
                <Button variant="info" onClick={() => setShowModal(false)}>
                  Je conserve la version actuelle
                </Button>
                <Button variant="success" onClick={handleUpgradeCalcul}>
                  Je convertis selon la nouvelle version
                </Button>
              </>
            ) : (
              <Button variant="info" onClick={() => setShowModal(false)}>
                Fermer
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      )}
      <div className="col col-xl-5">
        <PerfectScrollbar wheelpropagation={"false"}>
          <div className="card sticky-card">
            <div className="card-header card-head-inverse bg-primary">
              <h4 className="card-title">
                <span className="badge badge-pill badge-white-title">1</span>{" "}
                Saisir mes paramètres
              </h4>
            </div>
          </div>
          {familyProduct && familyProduct.currentFdes && (
            <>
              <FdesInformations
                fdes={calcul?.model || familyProduct.currentFdes}
                calcul={calcul}
                calculName={calcul?.title || ""}
                readOnly={isSimulationMode ? false : readOnly}
                metadata={findMetadata([NOMCALCUL, NOMPROJET])}
              />
              <FdesFormGroup
                isAuto={isAuto}
                readOnly={isSimulationMode ? false : readOnly}
                activeFdesId={activeFdesId}
                model={calcul?.model || familyProduct.currentFdes}
              />
            </>
          )}
        </PerfectScrollbar>
      </div>
      <div className="col col-xl-7">
        <PerfectScrollbar wheelpropagation={"false"}>
          <div className="card sticky-card">
            <div className="card-header card-head-inverse bg-primary">
              <h4 className="card-title refresh-button-container">
                <div>
                  <span className="badge badge-pill badge-white-title">2</span>{" "}
                  Afficher mes résultats
                </div>
                {isAuto === "N" && (
                  <button
                    onClick={handleSaveFdes}
                    type="button"
                    disabled={isEdited || readOnly || !isFormUpdated}
                    className="btn btn-secondary btn-min-width float-right"
                  >
                    Mettre à jour
                  </button>
                )}
                {isGoogleCalculus !== true && isApsiviCalculus !== true && (
                  <label>
                    <span className="mr-1">Mise à jour automatique</span>
                    <Switch
                      onChange={handleChangeIsAuto}
                      checked={isAuto === "Y"}
                    />
                  </label>
                )}
              </h4>
            </div>
          </div>
          <div
            className={`results-panel ${resultsAreStale ? "results-stale" : ""}`}
          >
            <SyntheticResult
              metadata={findMetadata([INDICATEURRS, ETAPESRS, AFFICHAGERSLT])}
              excludedCouples={excludedCouples}
              fdesParameters={fdesParameters}
              fdesPerUnit={calcul?.metadata?.unitLabel}
            />
            <ModuleResult
              metadata={findMetadata([
                INDICATEURM,
                RESULTATSPARETAPES,
                GRAPHERESULTATS,
                TABLEAUDETAIL,
              ])}
            />
          </div>
          <div className="card sticky-card sticky-card-bottom">
            <div className="d-flex flex-row flex-wrap justify-content-between card-header card-head-inverse bg-primary">
              <h4 className="card-title">
                <span className="badge badge-pill badge-white-title">3</span>{" "}
                Utiliser mes résultats{" "}
              </h4>
              <div className="ml-auto d-flex align-items-center">
                {calcul &&
                  reports?.xml &&
                  user.integrations &&
                  user.integrations.edec &&
                  !!user.integrations?.edec?.username &&
                  !!user.integrations?.edec?.password &&
                  !!localEDECIntegration?.data?.[0]?.value &&
                  !!localEDECIntegration?.data?.[1]?.value && (
                    <span
                      className={"icon-file active"}
                      onClick={() => sendXmlToEDEC(calcul)}
                    >
                      <span
                        data-tooltip-content={"Envoyer XML à EDEC"}
                        data-tooltip-id={`exportXmltoEDEC${calcul._id}`}
                      >
                        <img
                          src={EDECLogo}
                          alt="EDEC icon"
                          style={{ width: 15, marginBottom: 3 }}
                        />
                      </span>
                      <CustomTooltip
                        id={`exportXmltoEDEC${calcul._id}`}
                        place="left"
                      />
                    </span>
                  )}

                {displayDownloadXLS() &&
                  (isGeneratingReports ? (
                    <div className="spinner-border mr-1" role="status" />
                  ) : (
                    <>
                      <span
                        className={`icon-file ${reports?.xls &&
                            filesCreatedAfterSave &&
                            filesCreatedAfterSave()
                            ? "active"
                            : ""
                          }`}
                        data-tooltip-id="generateXls"
                        onClick={() => handleClickIcon("xls")}
                        data-tooltip-content={getDownloadFileContent("xls")}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-file-excel-o" />
                      </span>
                      <CustomTooltip id="generateXls" place="top" />
                    </>
                  ))}

                {displayDownloadXmlInies() &&
                  (isGeneratingReports ? (
                    <div className="spinner-border mr-1" role="status" />
                  ) : (
                    <>
                      <span
                        className={`icon-file ${reports?.inies &&
                            filesCreatedAfterSave &&
                            filesCreatedAfterSave()
                            ? "active"
                            : ""
                          }`}
                        data-tooltip-id="generateXmlInies"
                        onClick={() => handleClickIcon("inies")}
                        data-tooltip-content={getDownloadFileContent("inies")}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-file-text-o" />
                      </span>
                      <CustomTooltip id="generateXmlInies" place="top" />
                    </>
                  ))}

                {isGeneratingReports ? (
                  <div className="spinner-border mr-1" role="status" />
                ) : (
                  <>
                    <span
                      className={`icon-file ${reports?.pdf &&
                          filesCreatedAfterSave &&
                          filesCreatedAfterSave()
                          ? "active"
                          : ""
                        }`}
                      data-tooltip-id="generatePdf"
                      onClick={() => handleClickIcon("pdf")}
                      data-tooltip-content={getDownloadFileContent("pdf")}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <CustomTooltip id="generatePdf" place="top" />
                  </>
                )}

                {displayDownloadXmlConfig() &&
                  (isGeneratingReports ? (
                    <div className="spinner-border mr-1" role="status" />
                  ) : (
                    <>
                      <span
                        className={`icon-file ${reports?.xml &&
                            filesCreatedAfterSave &&
                            filesCreatedAfterSave()
                            ? "active"
                            : ""
                          }`}
                        data-tooltip-id="generateXml"
                        onClick={() => handleClickIcon("xml")}
                        data-tooltip-content={getDownloadFileContent("xml")}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-file-code-o" />
                      </span>
                      <CustomTooltip id="generateXml" place="top" />
                    </>
                  ))}

                <span
                  data-tooltip-id="generateFdes"
                  data-tooltip-content={
                    isGenerateButtonDisabled &&
                      !readOnly &&
                      !isGeneratingReports
                      ? createPdf && createPdf.helpText
                        ? createPdf.helpText
                        : "Pour générer une FDES vous devez d’abord enregistrer"
                      : ""
                  }
                  className="mr-1"
                >
                  <button
                    onClick={handleGenerateClick}
                    type="button"
                    disabled={isGenerateButtonDisabled}
                    className="btn btn-secondary btn-min-width"
                  >
                    {createPdf?.name || "Générer ma FDES"}
                  </button>
                  <CustomTooltip id="generateFdes" place="top" />
                </span>
                <span
                  data-tooltip-id="updateCalcul"
                  data-tooltip-content={
                    !isEdited
                      ? "Pour enregistrer vous devez d’abord mettre à jour le calcul"
                      : ""
                  }
                >
                  <button
                    onClick={handleSaveResult}
                    type="button"
                    disabled={isSaveButtonDisabled()}
                    className="btn btn-secondary btn-min-width"
                  >
                    Enregistrer
                  </button>
                  <CustomTooltip id="updateCalcul" place="top" />
                </span>
              </div>
            </div>
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );
};
export default Fdes;
